import { EventDispatcherBase, } from './EventDispatcherBase';
/**
 * Dispatches a {@link SubscribableFlagEvent}.
 *
 * @remarks
 * Subscribers are notified only when the flag is set.
 * Subsequent calls to {@link raise} don't trigger anything.
 * Any handlers added while the flag is raised are immediately invoked.
 *
 * Resetting the flag doesn't notify the subscribers, but raising it again does.
 *
 * @example
 * ```ts
 * class Example {
 *   // expose the event to external classes
 *   public get onChanged {
 *     return this.flag.subscribable;
 *   }
 *   // create a private dispatcher
 *   private flag = new FlagDispatcher();
 *
 *   private dispatchExample() {
 *     // setting the flag will notify all subscribers
 *     this.flag.raise();
 *   }
 * }
 * ```
 */
export class FlagDispatcher extends EventDispatcherBase {
    constructor() {
        super(...arguments);
        this.value = false;
    }
    /**
     * Notify all current and future subscribers.
     */
    raise() {
        if (!this.value) {
            this.value = true;
            this.notifySubscribers();
        }
    }
    /**
     * Stop notifying future subscribers.
     */
    reset() {
        this.value = false;
    }
    /**
     * Are subscribers being notified?
     */
    isRaised() {
        return this.value;
    }
    subscribe(handler) {
        const unsubscribe = super.subscribe(handler);
        if (this.value) {
            handler();
        }
        return unsubscribe;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmxhZ0Rpc3BhdGNoZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZXZlbnRzL0ZsYWdEaXNwYXRjaGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFDTCxtQkFBbUIsR0FHcEIsTUFBTSx1QkFBdUIsQ0FBQztBQUUvQjs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7R0EwQkc7QUFDSCxNQUFNLE9BQU8sY0FBZSxTQUFRLG1CQUF5QjtJQUE3RDs7UUFDVSxVQUFLLEdBQUcsS0FBSyxDQUFDO0lBaUN4QixDQUFDO0lBL0JDOztPQUVHO0lBQ0ksS0FBSztRQUNWLElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSyxFQUFFLENBQUM7WUFDaEIsSUFBSSxDQUFDLEtBQUssR0FBRyxJQUFJLENBQUM7WUFDbEIsSUFBSSxDQUFDLGlCQUFpQixFQUFFLENBQUM7UUFDM0IsQ0FBQztJQUNILENBQUM7SUFFRDs7T0FFRztJQUNJLEtBQUs7UUFDVixJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQztJQUNyQixDQUFDO0lBRUQ7O09BRUc7SUFDSSxRQUFRO1FBQ2IsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDO0lBQ3BCLENBQUM7SUFFTSxTQUFTLENBQUMsT0FBMkI7UUFDMUMsTUFBTSxXQUFXLEdBQUcsS0FBSyxDQUFDLFNBQVMsQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUM3QyxJQUFJLElBQUksQ0FBQyxLQUFLLEVBQUUsQ0FBQztZQUNmLE9BQU8sRUFBRSxDQUFDO1FBQ1osQ0FBQztRQUNELE9BQU8sV0FBVyxDQUFDO0lBQ3JCLENBQUM7Q0FDRiJ9